/* angular:styles/component:css;4cdf6b34261ae71feb5d1867ae7d0ecbea6989b9bdd5ee6b8aba6c17c26551d0;C:\Users\DGenz\OneDrive\07_Programmierung\01_PHPStorm\ELW-App - Kopie\src\app\registrieren\registrieren.component.ts */
.popup-login {
  padding: 50px 0 0 0px;
  width: 100%;
  height: 100%;
}
.form_row {
  padding: 50px 0 0 0px;
}
/*# sourceMappingURL=registrieren.component-7OQU2SUP.css.map */
